import React from 'react';
import { Toaster } from 'react-hot-toast';

function ToasterComponent() {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      containerStyle={{
        zIndex: 999999999999,
      }}
      toastOptions={{
        duration: 2000,
        style: {
          background: '#363636',
          color: '#fff',
        },
        success: {
          duration: 2000,
          theme: {
            primary: 'green',
            secondary: 'black',
          },
        },
      }}
    />
  );
}

export default ToasterComponent;
